import React from 'react';
import { Label } from '../typography';
import { Icon } from '../../ui/icon/old/icons';
import { StyledLink } from './style/styled';
export var Link = function Link(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      text = _ref.text,
      href = _ref.href,
      onClick = _ref.onClick,
      icon = _ref.icon,
      alternative = _ref.alternative,
      disabled = _ref.disabled,
      primary = _ref.primary,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'bold' : _ref$weight,
      id = _ref.id,
      _ref$hoverWeight = _ref.hoverWeight,
      hoverWeight = _ref$hoverWeight === void 0 ? 'bold' : _ref$hoverWeight,
      target = _ref.target;
  var linkHref = href ? href : '#';
  var clickFunction = onClick ? onClick : function () {
    return false;
  };
  return React.createElement(StyledLink, {
    id: id,
    weight: weight,
    hoverWeight: hoverWeight,
    size: size,
    href: !disabled ? linkHref : undefined,
    onClick: !disabled ? function () {
      return clickFunction();
    } : undefined,
    disabled: disabled,
    primary: primary,
    alternative: alternative,
    target: target
  }, icon ? React.createElement(Icon, {
    src: icon
  }) : null, React.createElement(Label, {
    hoverWeight: hoverWeight,
    weight: weight,
    size: size
  }, text));
};